import { createSlice } from "@reduxjs/toolkit";
import { similarNonprofitsListApi } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const similarNonprofitsSlice = createSlice({
  name: "similarNonprofits",
  initialState: data,
  reducers: {
    similarNonprofitsSlice(state) {
      state.isLoading = false;
    },
    similarNonprofitsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    similarNonprofitsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    similarNonprofitsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const similarNonprofitsHandler = () => async (dispatch: any) => {
  try {
    dispatch(similarNonprofitsAction.similarNonprofitsSlice());
    const response: any = await similarNonprofitsListApi();
    dispatch(similarNonprofitsAction.similarNonprofitsSliceSuccess(response));
  } catch (e: any) {
    dispatch(similarNonprofitsAction.similarNonprofitsSliceFailure(e?.response?.data?.message));
    dispatch(similarNonprofitsAction.similarNonprofitsSliceReset());
  }
};
export default similarNonprofitsSlice.reducer;
export const similarNonprofitsAction = similarNonprofitsSlice.actions;
